
(() => {
  const root = document.querySelector('.partners-page__about');
  if (!root) return;
  const nums = root.querySelectorAll('.partners-page__stat-value');
  if (!nums.length) return;

  const target = (el) => {
    const raw = el.textContent.trim();
    return /^\d+$/.test(raw) ? parseInt(raw, 10) : null;
  };

  const animate = (el, duration) => {
    const to = target(el);
    if (to === null) return;
    let t0 = null;
    let shown = -1;
    el.style.contain = 'layout style paint';
    el.style.fontVariantNumeric = 'tabular-nums';
    el.style.minWidth = `${el.offsetWidth}px`;
    requestAnimationFrame(function step(now) {
      if (!t0) t0 = now;
      const p = Math.min((now - t0) / duration, 1);
      const v = Math.floor(p * to);
      if (v !== shown) { shown = v; el.textContent = v; }
      if (p < 1) requestAnimationFrame(step);
      else if (shown !== to) el.textContent = to;
    });
  };

  let started = false;
  const start = () => {
    if (started) return;
    started = true;
    nums.forEach((el) => animate(el, 1500));
  };

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { start(); io.disconnect(); } });
    }, { threshold: 0.4 });
    io.observe(root);
  } else {
    start();
  }
})();
